module.exports = "images/shape.4e0d0926.png";